<template lang="pug">
.review-page-setup-preview
  preview
    preview-item(:title="$t('review_page_preview_title')")
      preview-iphone.mt-4(home-bar)
        //- Logo
        .my-8
          v-card(v-if="resizeImageFileUrl" flat)
            div(align="center")
              v-img(:src="resizeImageFileUrl" contain max-height="64" max-width="64")
                template(v-slot:placeholder)
                  v-row(class="fill-height ma-0" align="center" justify="center")
                    v-progress-circular(indeterminate color="grey")
          v-avatar(v-else size="64" color="neutral300")
            span.text-md.font-semibold.neutral500--text {{ getInitial(company.name) }}
        v-divider
        //- Heading
        .h6.my-4 {{ heading }}
        //- Description
        .text-sm.my-4.pre-wrap(v-html="description")
        //- Rating scale
        v-card.pa-4(outlined)
          .text-sm.mb-4 {{ $t('review_page_preview_rate_question') }}
          v-card.px-4.py-2.my-2.mx-2(v-for="(star, starIndex) in totalStar" :key="`preview-${starIndex}`" outlined)
            v-row(no-gutters)
              v-col
                star-generator(:totalStar="totalStar" :star="totalStar - starIndex" :size="20" classes="mr-1")
              v-col.text-right
                .text-sm {{ starDescriptions[totalStar - starIndex - 1] }}
        //- Safari search bar
        preview-iphone-safari-search-bar.my-4(:search="reviewLink")
</template>

<script>
import { mapGetters } from 'vuex'
import Preview from '@/components/review/preview/Preview.vue'
import PreviewItem from '@/components/review/preview/PreviewItem.vue'
import PreviewIphone from '@/components/review/preview/PreviewIphone.vue'
import PreviewIphoneSafariSearchBar from '@/components/review/preview/PreviewIphoneSafariSearchBar.vue'
import StarGenerator from '@/components/review/general/StarGenerator.vue'

export default {
  name: 'ReviewPageSetupPreview',
  components: {
    Preview,
    PreviewItem,
    PreviewIphone,
    PreviewIphoneSafariSearchBar,
    StarGenerator
  },
  props: {
    resizeImageFileUrl: {
      type: String,
      default: null
    },
    heading: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    totalStar: {
      type: Number,
      default: 5
    },
    starDescriptions: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
   computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    reviewLink() {
      if (process.env.VUE_APP_ENV === 'prod') {
        return `https://review.yezza.co/review/...`
      }
      return `https://review-test.yezza.co/review/...`
    }
  },
  methods: {
    getInitial (value) {
      let name = value
      let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
      let initials = [...name.matchAll(rgx)] || [];
      initials = ((initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')).toUpperCase();
      return initials
    },
  },
}
</script>

<style scoped>
.pre-wrap {
  white-space: pre-wrap;
}
</style>